import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Tache } from 'src/app/shared/models/tache';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TacheModalAjoutComponent } from '../modal/tache-modal-ajout/tache-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { TacheModalDetailComponent } from '../modal/tache-modal-detail/tache-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-tache',
	templateUrl: './list-tache.component.html',
	styleUrls: ['./list-tache.component.scss']
})
export class ListTacheComponent implements OnInit {
	tache: Tache[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	tacheCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editTacheModalRef: BsModalRef;
	addTacheModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getTache();
		this.isAddable = true;
	}

	getTache(): void {
		this.isListingLoading = true;
		this.facade.tacheService.getAllTache().subscribe({
			next: (val) => {
				this.tache = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.tache.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.tache = [];
			}
		});
	}

	selectTache(tache: Tache): void {
		const link = ['/tache', tache.id];
		this.router.navigate(link);
	}

	importTache(event: any): void {
		this.tacheCsvFile = event.target.files[0];

		this.facade.tacheService
			.importTache(this.tacheCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} tache ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getTache();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addTacheModalRef = this.modalService.show(
			TacheModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addTacheModalRef.onHide.subscribe((reason: string | any) => {
			this.getTache();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(tache: Tache) {
		const initialState = {
			tache: tache
		};
		this.editTacheModalRef = this.modalService.show(
			TacheModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editTacheModalRef.onHide.subscribe((reason: string | any) => {
			this.getTache();
		});
	}
}
